import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _authService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const start = request.url.startsWith('http');

    const url = start ? request.url : `${environment.backend.url}/${request.url}`;
    if (start) {
      request = request.clone({ url: url, setHeaders: { 'X-Platform-Version': '1.2.0' } });
    } else if (this._authService.jwt) {
      request = request.clone({
        url: url,
        setHeaders: { Authorization: `Bearer ${this._authService.jwt.token}`, 'X-Platform-Version': '1.2.0' },
      });
    }

    return next.handle(request);
  }
}
